// extracted by mini-css-extract-plugin
export default {"projectMenuTags":"projectMenuTags__qCpg7q","projectMenuTagsSection":"projectMenuTagsSection__lHOraE"};